import { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IUserInfoResponse } from "Data/interfaces/MinhaConta/IUserInfoResponse";
import { IObraResponse } from "Data/interfaces/Obra/IObraListResponse";
import * as Yup from 'yup';
import Tooltip from "Components/UI/Tooltip";
import Button from "Components/UI/Button";
import { Icon } from "Components/UI/Icon";
import Form from "Components/UI/Form/Form";
import Field from "Components/UI/Field";
import { ActionsContainer } from "./styles";

export enum ROLES {
  ADMIN = 1,
  COORDENADOR = 7
}

export interface IHeaderActions {
  minhaConta: IUserInfoResponse;
  obras?: IObraResponse[];
  isLoading: boolean;
  obrasForShow: boolean;
  openCadastroObra: () => void;
  onRemoveSearch: () => void;
  onSearch: (search: string) => void;
  onSearchChange: (search: string) => void;
}

export const HeaderActions: FC<IHeaderActions> = ({
  minhaConta,
  isLoading,
  obras,
  obrasForShow,
  onSearch,
  onSearchChange,
  onRemoveSearch,
  openCadastroObra,
}) => {
  const { t } = useTranslation('obras');
  const [showCSSearchInput, setShowCSSearchInput] = useState(false);
  const [search, setSearch] = useState('');
  const allowedRoles = [ROLES.ADMIN, ROLES.COORDENADOR];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const searchInput = document.querySelector('.search-obra-input');
      if (searchInput && !searchInput.contains(event.target as Node) && !search) {
        setShowCSSearchInput(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [search]);

  if (
    !allowedRoles.includes(minhaConta.CurrentRoleFk) ||
    (!isLoading && obras === undefined)
  ) {
    return <></>;
  }

  const handleSearchChange = (value: string) => {
    setSearch(value);
    onSearchChange(value);
  };

  const onSearchSubmit = (values: { search: string }) => {
    setShowCSSearchInput(false);
    onSearch(values.search);
  };

  const toggleSearchInput = () => {
    onRemoveSearch();
    setSearch('');
    setShowCSSearchInput(true);
  };

  return (
    <ActionsContainer>
      {obrasForShow && (
        <>
          {showCSSearchInput && (
            <Form
              schema={Yup.object().shape({})}
              className="form-container"
              onSubmit={onSearchSubmit}
            >
              <Field
                name="search"
                label=""
                icon="buscar"
                autoFocus={true}
                className="search-obra-input"
                placeholder={t('searchPlaceholder')}
                value={search}
                onInput={handleSearchChange}
              />
            </Form>
          )}
          {!showCSSearchInput && (
            <Tooltip title={t('tooltipFilter')}>
              <Button
                type='text'
                height={36}
                width={36}
                shape="circle"
                className="buttonObra"
                onClick={toggleSearchInput}
              >
                <Icon icon='buscar' customSize={16} />
              </Button>
            </Tooltip>
          )}
        </>
      )}

      <Tooltip title={t('tooltipAddNew')}>
        <Button
          height={45}
          shape="circle"
          className="buttonObra"
          onClick={openCadastroObra}
        >
          <Icon
            icon="adicionar"
            customSize={20}
            color="onPrimary"
            style={{ fontWeight: 700 }}
          />
        </Button>
      </Tooltip>
    </ActionsContainer>
  );
}
